import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_SURVEYCATEGORIE,
  DELETE_SURVEYCATEGORIE,
  GET_SURVEYCATEGORIES,
  UPDATE_SURVEYCATEGORIE,
  UPDATE_SURVEYCATEGORIE_STATUS
} from "./actionTypes";

import {
  addSurveyCategorieFail,
  addSurveyCategorieSuccess,
  deleteSurveyCategorieFail,
  deleteSurveyCategorieSuccess,
  getSurveyCategoriesFail,
  getSurveyCategoriesSuccess,
  setState,
  updateSurveyCategorieFail,
  updateSurveyCategorieSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { surveyCategories, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchSurveyCategories({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, surveyCategories, params.toString());
    yield put(setState(false));
    yield put(getSurveyCategoriesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getSurveyCategoriesFail(error));
  }
}

function* updateSurveyCategorie({ payload: surveyCategorieObj }) {
  try {
    const { id, recordStatus, ...rest } = surveyCategorieObj;
    yield call(patchApiCall, `${surveyCategories}/${id}`, rest);
    const response = yield call(getTable, `${surveyCategories}/${surveyCategorieObj.id}`);
    yield put(updateSurveyCategorieSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateSurveyCategorieFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateSurveyCategorieStatus({ payload: surveyCategorieObj }) {
  try {
    const { id } = surveyCategorieObj;
    yield call(patchApiCall, `${surveyCategories}/${updateStatus}/${id}`, { recordStatus: surveyCategorieObj.recordStatus });
    const response = yield call(getTable, `${surveyCategories}/${surveyCategorieObj.id}`);
    yield put(updateSurveyCategorieSuccess(response));
  } catch (error) {
    yield put(updateSurveyCategorieFail(error));
  }
}

function* deleteSurveyCategorie({ payload: surveyCategorieObj }) {
  try {
    yield call(deleteApiCall, `${surveyCategories}/${surveyCategorieObj.id}`);
    yield put(deleteSurveyCategorieSuccess(surveyCategorieObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteSurveyCategorieFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingSurveyCategorie({ payload: surveyCategorie }) {
  try {
    const response = yield call(postApiCall, surveyCategories, surveyCategorie);
    yield put(addSurveyCategorieSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addSurveyCategorieFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* surveyCategoriesSaga() {
  yield takeEvery(GET_SURVEYCATEGORIES, fetchSurveyCategories);
  yield takeEvery(ADD_NEW_SURVEYCATEGORIE, postingSurveyCategorie);
  yield takeEvery(UPDATE_SURVEYCATEGORIE, updateSurveyCategorie);
  yield takeEvery(UPDATE_SURVEYCATEGORIE_STATUS, updateSurveyCategorieStatus);
  yield takeEvery(DELETE_SURVEYCATEGORIE, deleteSurveyCategorie);
}

export default surveyCategoriesSaga;
